import { SwitchDataCycleComponent } from './switch-data-cycle/switch-data-cycle.component'
import { UpdateDataCycleComponent } from './update-data-cycle/update-data-cycle.component'
import { CreateDataCycleComponent } from './create-data-cycle/create-data-cycle.component'
import { DataCyclesComponent } from './data-cycles.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const contactTitlesRoutes: Routes = [
  {
    path: 'admin/data-cycles',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'DATA_CYCLE_MANAGEMENT',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', component: DataCyclesComponent },
      {
        path: 'create',
        component: CreateDataCycleComponent,
        data: {
          permissions: {
            only: 'CREATE_DATA_CYCLE',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'switch',
        component: SwitchDataCycleComponent,
        data: {
          permissions: {
            only: 'SWITCH_DATA_CYCLE',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateDataCycleComponent,
        data: {
          permissions: {
            only: 'UPDATE_DATA_CYCLE',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
